<script lang="ts" setup>
import SimpleSelectField from '@/components/input/SimpleSelectField.vue';
import { i18n } from '@/i18n';
import { computed } from 'vue';
import { useYearMonthPickerStore } from '../store/useYearMonthPickerStore';

// store
const yearMonthPickerStore = useYearMonthPickerStore();

// props
const props = withDefaults(
  defineProps<{
    inputDate?: Date;
  }>(),
  {
    // eslint-disable-next-line jsdoc/require-jsdoc
    inputDate: () => new Date(),
  }
);

// emits
const emits = defineEmits<{
  (e: 'changeValue', date: Date): void;
}>();

//変数
const t = i18n.t;

//computed
const date = computed({
  /**
   * getメソッド
   */
  get: () => props.inputDate,
  /**
   * setメソッド
   * @param value - props.inputDate
   */
  set: (value) => {
    // 値に変更があると呼ばれるsetter
    if (!value) {
      return;
    }
    emits('changeValue', value);
  },
});

/**
 * 選択された日付情報に描画の更新を行う
 * @param receiveValue - 子から渡ってきた値
 * @param receiveDateType - 年月どちらが更新されたか(汎用性特に無いので、そのままunion入れてます)
 */
const updateValue = (receiveValue: string, receiveDateType: 'year' | 'month') => {
  switch (receiveDateType) {
    case 'year':
      date.value.setDate(1);
      date.value.setFullYear(Number(receiveValue));
      break;
    case 'month':
      date.value.setDate(1);
      date.value.setMonth(Number(receiveValue));
      break;
  }
};
</script>

<template>
  <div class="year-month-picker__content">
    <div class="year-picker-container">
      <SimpleSelectField
        class="year-picker-container__content"
        :options="yearMonthPickerStore.initSelectedYearValue(props.inputDate)"
        :selected-value="`${date.getFullYear()}`"
        @update:model-value="updateValue($event, 'year')"
      />
      <label class="year-picker-container__title">
        {{ t('年') }}
      </label>
    </div>
    <div class="month-picker-container">
      <SimpleSelectField
        class="month-picker-container__content"
        :options="yearMonthPickerStore.initSelectedMonthValue()"
        :selected-value="`${date.getMonth()}`"
        @update:model-value="updateValue($event, 'month')"
      />
      <label class="month-picker-container__title">
        {{ t('月') }}
      </label>
    </div>
  </div>
</template>

<style scoped>
.year-month-picker__content {
  display: grid;
  padding: 24px;
  margin-right: 12px;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr);
}
.year-picker-container {
  display: flex;
}
.year-picker-container__title {
  font-size: medium;
}
.month-picker-container {
  display: flex;
}
.month-picker-container__title {
  font-size: medium;
}
</style>
